import sellerStep1 from './GuideSteps/SellerStages/1.webp'
import sellerStep2 from './GuideSteps/SellerStages/2.webp'
import sellerStep3 from './GuideSteps/SellerStages/3.webp'
import sellerStep4 from './GuideSteps/SellerStages/4.webp'
import sellerStep5 from './GuideSteps/SellerStages/5.webp'
import sellerStep6 from './GuideSteps/SellerStages/6.webp'
import sellerStep7 from './GuideSteps/SellerStages/7.webp'
import sellerStep8 from './GuideSteps/SellerStages/8.webp'
import sellerStep9 from './GuideSteps/SellerStages/9.webp'
import sellerStep10 from './GuideSteps/SellerStages/10.webp'
import sellerStep11 from './GuideSteps/SellerStages/11.webp'
import sellerStep12 from './GuideSteps/SellerStages/12.webp'
import sellerStep13 from './GuideSteps/SellerStages/13.webp'
import sellerStep14 from './GuideSteps/SellerStages/14.webp'
import sellerStep15 from './GuideSteps/SellerStages/15.webp'

import buyerStep1 from './GuideSteps/BuyerStages/1.webp';
import buyerStep2 from './GuideSteps/BuyerStages/2.webp';
import buyerStep3 from './GuideSteps/BuyerStages/3.webp';
import buyerStep4 from './GuideSteps/BuyerStages/4.webp';
import buyerStep5 from './GuideSteps/BuyerStages/5.webp';
import buyerStep6 from './GuideSteps/BuyerStages/6.webp';
import buyerStep7 from './GuideSteps/BuyerStages/7.webp';
import buyerStep8 from './GuideSteps/BuyerStages/8.webp';
import buyerStep9 from './GuideSteps/BuyerStages/9.webp';
import buyerStep10 from './GuideSteps/BuyerStages/10.webp';
import buyerStep11 from './GuideSteps/BuyerStages/11.webp';
import buyerStep12 from './GuideSteps/BuyerStages/12.webp';
import buyerStep13 from './GuideSteps/BuyerStages/13.webp';

const sellerStages = [
    {
        title:       'Начало работы',
        description: 'Избранные тендеры – это список тендеров, в которых Вы являетесь одобренным Поставщиком и можете принять участие.',
        img:         sellerStep1,
    },
    {
        title:       'Принять участие',
        // eslint-disable-next-line max-len
        description: 'Для начала работы с тендером дождитесь начала торгов. При появлении статуса «Идут торги» откройте тендер двойным щелчком левой кнопки мыши.',
        img:         sellerStep2,
    },
    {
        title:       'Участие в торгах',
        description: 'Чтобы начать участие в торгах, необходимо нажать кнопку "Сделать ставку" и создать или добавить предложение',
        img:         sellerStep3,
    },
    {
        title:       'Создание предложения',
        // eslint-disable-next-line max-len
        description: 'Для участия в торгах необходимо один раз создать предложение. Созданное предложение в будущем Вы сможете использовать повторно в следующих тендерах.',
        img:         sellerStep4,
    },
    {
        title:       'Заполнение данных',
        // eslint-disable-next-line max-len
        description: 'Заполните форму предложения, используя подсказки системы. Подсказки указывают на требования к характеристикам, количеству, срокам поставки товара и прочие пожелания Покупателя. Примите условия Договора и сохраните предложение. После сохранения предложения откроется карточка редактирования ставки.',
        img:         sellerStep5,
    },
    {
        title:       'Создание ставки',
        // eslint-disable-next-line max-len
        description: 'Если Ваша ставка не лучшая в тендере, то будет выведена подсказка о той цене, которую можно выбрать, чтобы стать лидером. При нажатии на подсказку цена обновится. Вы можете установить самостоятельно ставку.',
        img:         sellerStep6,
    },
    {
        title:       'Конечная цена',
        // eslint-disable-next-line max-len
        description: 'Лучшая цена определяется по «Конечной цене для покупателя». Конечная цена для покупателя складывается из Вашей цены и наценок.',
        img:         sellerStep7,
    },
    {
        title:       'Кредитная наценка',
        // eslint-disable-next-line max-len
        description: 'Кредитная наценка влияет на конечную цену для покупателя. Вы можете согласится с проведением оплаты за поставленный товар по стандартной отсрочке, тогда кредитная наценка будет равна 0% и не окажет влияния на конечную цену для покупателя.',
        img:         sellerStep8,
    },
    {
        title:       'Способ доставки',
        // eslint-disable-next-line max-len
        description: 'Способ доставки влияет на конечную цену для покупателя. Вы можете выбрать способ доставки «Я доставляю самостоятельно», тогда наценка за доставку будет равна 0% и не окажет влияния на конечную цену для покупателя.',
        img:         sellerStep9,
    },
    {
        title:       'Корректировка предложения',
        // eslint-disable-next-line max-len
        description: 'Вы можете изменить большинство параметров своего предложение в тендере во вкладках «Основное» и «Другое». Характеристики Товара меняются только в предложении, которое сохраняется в разделе «Товарные предложения»',
        img:         sellerStep10,
    },
    {
        title:       'Виды тендеров',
        // eslint-disable-next-line max-len
        description: 'Все торги проводятся в виде закрытого электронного аукциона и делятся по способу выборки товара на два вида: Первый – аукцион с полной выборкой/поставкой всего количества в определенную дату - это «аукцион для заказа»; Второй – аукцион с полной выборкой/поставкой всего количества в определенный временной интервал - это «аукцион для предзаказа». По количеству возможных победителей аукционы делятся на два вида: Первый – аукцион, где может победить только 1 участник; Второй – аукцион, где могут победить 2 участника – это аукцион «70/30%»',
        img:         sellerStep11,
    },
    {
        title:       'Основные индикаторы 1',
        description: 'Зеленый цвет ставки означает, что Ваша ставка лучшая по сравнению с конкурентами.',
        img:         sellerStep12,
    },
    {
        title:       'Основные индикаторы 2',
        // eslint-disable-next-line max-len
        description: 'При назначении Поставщиками ставок выше «Стартовой цены» Покупатель имеет право отказаться от размещения заказа или в течение трех рабочих дней разместить заказ Поставщику, сделавшему наименьшую ставку',
        img:         sellerStep13,
    },
    {
        title:       'Основные индикаторы 3',
        // eslint-disable-next-line max-len
        description: 'Если в закрытом электронном аукционе 70/30% Вы заняли второе место, то Вам размещается заказ на 30% с учетом кратности упаковки. Для детального просмотра аукционов нужно два раза кликнуть левой кнопкой мыши по аукциону',
        img:         sellerStep14,
    },
    {
        title:       'Сравнение цен',
        // eslint-disable-next-line max-len
        description: 'В тендерах сравнение цен для определения Победителей происходит по колонке «Полная цена с отсрочкой». С правилами проведения тендеров можно ознакомиться в договоре.',
        img:         sellerStep15,
    }
];

const buyerStages = [
    {
        title:       'Поиск тендера',
        // eslint-disable-next-line max-len
        description: 'Список тендеров - это актуальный спрос покупателя. Найдите ваши позиции в списке тендеров или воспользуйтесь поиском.',
        img:         buyerStep1,
    },
    {
        title:       'Добавить в избранное',
        // eslint-disable-next-line max-len
        description: 'Нажатием правой кнопки мыши по тендеру вы можете вызвать контекстное меню и добавить этот тендер в избранное.',
        img:         buyerStep2,
    },
    {
        title:       'Посмотреть “Избранное”',
        // eslint-disable-next-line max-len
        description: 'Раздел “Избранное” сделан для более удобного отслеживания и управления актуальными тендерами.',
        img:         buyerStep3,
    },
    {
        title:       'Создание тендера',
        // eslint-disable-next-line max-len
        description: 'Чтобы создать тендер необходимо выбрать сырье из листа потребностей и в пункте меню выбрать “Создать тендер”',
        img:         buyerStep4,
    },
    {
        title:       'Карточка тендера',
        // eslint-disable-next-line max-len
        description: 'Заполните данные в карточке тендера и сохраните его. Обратите внимание, что стартовая цена не обязательно должна являться бюджетной, может быть меньше.',
        img:         buyerStep5,
    },
    {
        title:       'Начало торгов',
        // eslint-disable-next-line max-len
        description: 'Посмотрите как идут торги в разделе ”Тендеры”.',
        img:         buyerStep6,
    },
    {
        title:       'Тендеры 70%+30%',
        // eslint-disable-next-line max-len
        description: 'Тендер 70%+30% — закрытый аукцион, где побеждают два поставщика с наименьшими ставками. Первый, предложивший лучшую цену, получает заказ на 70% товара по потребности покупателя (округлено в большую сторону, кратно фасовке). Второй — на оставшиеся 30% по своей цене.',
        img:         buyerStep7,
    },
    {
        title:       'Посмотреть ставки',
        description: 'В карточке тендера, по двойному нажатию левой кнопки мыши, можно посмотреть кто участвует и как делает ставки.',
        img:         buyerStep8,
    },
    {
        title:       'Выбрать победителя',
        // eslint-disable-next-line max-len
        description: 'По окончании времени тендер получает статус “Завершен”. После этого вы можете перейти к тендеру и выбрать наилучшее предложение, через меню выбора победителя.',
        img:         buyerStep9,
    },
    {
        title:       'Подсказки цен',
        // eslint-disable-next-line max-len
        description: 'При наведении мыши на заголовки "Цена", "Полная цена" и "Полная цена с отсрочкой" вы можете увидеть подсказку, поясняющее значение данной колонки.',
        img:         buyerStep11,
    },
    {
        title:       'Отбор победителя',
        // eslint-disable-next-line max-len
        description: 'Вы можете проверить утвержденных производителей, характеристики, условия по срокам, количеству, наилучшей цене и оформить заказ.',
        img:         buyerStep10,
    },
    {
        title:       'Просмотр заказов',
        // eslint-disable-next-line max-len
        description: 'Посмотрите созданные вами заказы по тендерам в разделе “Заказ создан”. В рамках одного тендера может быть оформлено несколько заказов для обеспечения потребности.',
        img:         buyerStep12,
    },
    {
        title:       'Итоги по тендерам',
        // eslint-disable-next-line max-len
        description: 'Поставщик получит письмо на электронную почту о размещенном заказе. А также вся информация о проведении тендера будет храниться в истории тендера на сайте.',
        img:         buyerStep13,
    },
];


export {
    sellerStages,
    buyerStages,
};
